import {
  minLength,
  maxLength,
  required,
  requiredIf,
  sameAs,
  numeric,
  alphaNum
} from 'vuelidate/lib/validators'

import {
  req,
  withParams,
  regex
} from 'vuelidate/lib/validators/common'

const min = min =>
  withParams({type: 'min', min}, value =>
    !req(value) || (!/\s/.test(value) && min <= value))

const max = max =>
  withParams({type: 'max', max}, (value) =>
    !req(value) || (!/\s/.test(value) && max >= value))

const numfloat = regex('numfloat', /^(\+)?\d+(\.\d+)?$/)
const mixNumfloat = regex('mixNumfloat', /^(-|\+)?\d+(\.\d+)?$/)

export const validations = ({formList, columns}) => {
  let formValues = {}
  formList.map(formItem => {
    const rules = columns[formItem].form.rules
    if (rules && rules.length) {
      formValues[formItem] = {}
      rules.map(rule => {
        const { type, value } = rule
        formValues[formItem][type] = rule.dataType === 'boolean' && type === 'required' ? requiredIf(false)
          : type === 'required' ? required
          : type === 'minLength' ? minLength(value)
          : type === 'maxLength' ? maxLength(value)
          : type === 'min' ? min(value)
          : type === 'max' ? max(value)
          : type === 'sameAs' ? sameAs(value)
          : type === 'numfloat' ? numfloat  // 正数、小数、整数
          : type === 'mixNumfloat' ? mixNumfloat // 负数、整数、小数
          : type === 'numeric' ? numeric // 整数
          : type === 'alphaNum' ? alphaNum  // 整数和英文
          : null
      })
    }
  })
  return {
    formValues
  }
}



// WEBPACK FOOTER //
// ./src/components/SmartForm/validations.js